import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Instagram from "../layouts/Instagram";
import Content from "../sections/home/Content";

const pagelocation = "Homepage";

class Home extends Component {
  render() {
    return (
      <Fragment>
        <MetaTags>
          <title>
            Tilakamx - Church & Shop - React Template | {pagelocation}
          </title>
          <meta name="description" content="#" />
        </MetaTags>
        <Header />
        <Content />
        <Instagram />
        <Footer />
      </Fragment>
    );
  }
}

export default Home;
